import React from 'react';

import Chip from 'components/Chip/Chip';

export const CustomChip = () => (
  <div className="w-full mt-2.5 justify-center flex items-center">
    <div className="h-1.5 w-1.5 bg-indigo-600 rounded-full" />
    <div className="w-6 border-[1px] border-indigo-600 h-[1px] border-dashed mx-0.5" />
    <Chip className=" bg-violet-100 text-blue-950">And</Chip>
    <div className="w-6 border-[1px] border-indigo-600 h-[1px] border-dashed mx-0.5" />
    <div className="h-1.5 w-1.5 bg-indigo-600 rounded-full" />
  </div>
);
